import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { downloadHref, getApiErrorMessage } from '@/utils'

export type ExportMarketShopInventoryRequest = {
  buildingId: number
}

export type DownloadInventoryRequest = ExportMarketShopInventoryRequest & {
  fileName: string
}

export const exportMarketShopInventory = async (data: ExportMarketShopInventoryRequest) => {
  const response = await authAPI.get<Blob>('/market-shop/export-products', {
    params: data,
    responseType: 'blob',
  })
  return response.data
}

export const useExportMarketShopInventory = () => {
  const objectUrlRef = useRef<string | null>(null)

  const mutation = useMutation({
    mutationFn: async ({ fileName, ...rest }: DownloadInventoryRequest) => {
      const blob = await exportMarketShopInventory(rest)
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
      objectUrlRef.current = URL.createObjectURL(blob)
      downloadHref(objectUrlRef.current, fileName)
      return objectUrlRef.current
    },
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
  })

  // Note: Clean up the URL object when the hook unmounts
  useEffect(() => {
    return () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
    }
  }, [])

  return mutation
}
